import { createFileRoute, redirect } from '@tanstack/react-router';
import { SELECTED_LOOP_STORAGE_KEY } from '@/components/common/loop-header/SelectedLoopContext';
import { LoopsApi } from '@/lib/api/item-store/loops';
import { commonQueryKeys } from '@/lib/query-keys/common';

const readStoredLoopId = (): number | undefined => {
  try {
    const stored = localStorage.getItem(SELECTED_LOOP_STORAGE_KEY);
    const parsed = stored ? Number(stored) : Number.NaN;
    return Number.isFinite(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export const Route = createFileRoute('/(app)/org/$org/')({
  loader: async ({ context: { queryClient, organizationId }, params: { org } }) => {
    const loopsResponse = await queryClient.ensureQueryData({
      queryKey: commonQueryKeys.loops.all(organizationId ?? ''),
      queryFn: () => LoopsApi.getLoops(),
    });
    const loops = loopsResponse.data;

    const storedLoopId = readStoredLoopId();
    const lastVisited = storedLoopId ? loops.find((loop) => loop.id === storedLoopId) : undefined;

    if (lastVisited) {
      throw redirect({
        to: '/org/$org/loop/$loopId',
        params: { org, loopId: lastVisited.id },
        replace: true,
      });
    }
    const lastCreated = [...loops].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )[0];

    if (!lastCreated) {
      return;
    }

    throw redirect({
      to: '/org/$org/loop/$loopId',
      params: { org, loopId: lastCreated.id },
      replace: true,
    });
  },
});
